import type { QueryClient } from "@tanstack/react-query";
import { invalidatePlanQueries } from "@/shared/utils/planCache";

// Everything a WO mutation can touch. Bundle ownership resolves the part number
// on the bundle tables and gantts, the saw check tolerances and the overview
// counts, so link/unlink invalidates the bundle-side reads too.
const WORK_ORDER_QUERY_KEYS = [
	["workOrders"],
	["workOrderNumberPreview"],
	["workOrderForTiming"],
	["workOrderPendingCounts"],
	["bundlesData"],
	["recentBundlesForTiming"],
	["sawRecentBundles"],
	["bundleReclassification"],
	["sawReclassifyProducts"],
	["sawQualityChecks"],
	["ganttData"],
	["sawGanttData"],
	["weldlineOverview"],
	["sawOverview"],
];

export const invalidateWorkOrderQueries = async (queryClient: QueryClient) => {
	await Promise.all([
		...WORK_ORDER_QUERY_KEYS.map((queryKey) =>
			queryClient.invalidateQueries({ queryKey }),
		),
		// A work order mutation can move its planned block, so the calendar and
		// the undo entry follow it
		invalidatePlanQueries(queryClient, { planChange: true }),
	]);
};
